import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"#31344A\" fill-rule=\"evenodd\" clip-path=\"url(#i2124743132__a)\" clip-rule=\"evenodd\"><path d=\"M11 .063c.434 0 .786.352.786.786v20.428a.786.786 0 0 1-1.572 0V.85c0-.434.352-.786.786-.786Z\"></path><path d=\"M0 11c0-.434.352-.786.786-.786h20.428a.786.786 0 0 1 0 1.572H.786A.786.786 0 0 1 0 11Z\"></path></g><defs><clipPath id=\"i2124743132__a\"><path fill=\"#fff\" d=\"M0 0h22v22H0z\"></path></clipPath></defs>", 2)
  ])))
}
export default { render: render }